import type { StandardSubtitleProps } from './types'
import type { EventDescription } from '~/composables/types/event'
import { eventGetters } from '~/utils/eventGetters'

export const getStandardPriceSubtitleText = (
  kftEvent: EventDescription | undefined,
  t: (key: string, params?: Record<string, unknown>) => string
): string => {
  if (!eventGetters.getDefaultFormattedPrice(kftEvent)) return ''

  const translationKey = eventGetters.isBoxEvent(kftEvent)
    ? 'product.show.checkout.priceSubtitleKit'
    : 'product.show.checkout.priceSubtitle'

  return t(translationKey, {
    price: eventGetters.getDefaultFormattedPrice(kftEvent),
  })
}

export const getStandardFormattedSubtitle = (
  kftEvent: EventDescription | undefined,
  originalPricePerPerson: string | undefined,
  hasSale: boolean,
  hasSingleCategory: boolean,
  t: (key: string, params?: Record<string, unknown>) => string
): string => {
  const discountedPrice = eventGetters.getDefaultFormattedPrice(kftEvent)
  if (!discountedPrice) return ''

  const shouldShowOriginalPrice =
    originalPricePerPerson && hasSale && hasSingleCategory

  const translationKey = eventGetters.isBoxEvent(kftEvent)
    ? 'product.show.checkout.priceSubtitleKit'
    : 'product.show.checkout.priceSubtitle'

  if (!shouldShowOriginalPrice) {
    return getStandardPriceSubtitleText(kftEvent, t)
  }

  const tempPlaceholder = '__PRICE_PLACEHOLDER__'
  const translationWithPlaceholder = t(translationKey, {
    price: tempPlaceholder,
  })

  return translationWithPlaceholder.replace(
    tempPlaceholder,
    `<span class="line-through text-gray-400">${originalPricePerPerson}</span> ${discountedPrice}`
  )
}

export const getStandardSubtitleProps = (
  formattedSubtitle: string
): StandardSubtitleProps => ({
  variant: 'standard',
  formattedSubtitle,
})
